import Icon from '@mui/material/Icon';
// import { ReactComponent as PackageSearchIcon } from '../../static/img/package_search.svg';
import { ReactComponent as CloseOutIcon } from '../../static/img/closeout.svg';
import { ReactComponent as ProductCatalogIcon } from '../../static/img/product_catalog.svg';

export interface NavProps {
  id: number;
  primary: string;
  to: string;
  icon: JSX.Element;
  collapsible?: boolean;
  subItems?: NavProps[];
  claimType?: string;
  claimValue?: string;
}

export const primaryList: NavProps[] = [
  {
    id: 0,
    primary: 'Dashboard',
    to: '/',
    icon: <Icon>dashboard</Icon>,
    collapsible: false,
  },
  {
    id: 100,
    primary: 'Service Monitor',
    to: '/service_monitor',
    icon: <Icon>lan</Icon>,
    collapsible: false,
    claimType: 'UI-Access',
    claimValue: 'Service Monitor',
  },
  {
    id: 200,
    primary: 'Packing',
    to: '/',
    icon: <Icon>warehouse</Icon>,
    collapsible: true,
    claimType: 'UI-Access',
    claimValue: 'Manage Packing',
    subItems: [
      {
        id: 201,
        primary: 'Conveyor Monitor',
        to: '/conveyor_monitor',
        icon: <Icon>conveyor_belt</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'ConveyorMonitor',
      },
      {
        id: 202,
        primary: 'Packing Monitor',
        to: '/packing_monitor',
        icon: <Icon>monitor</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'PackingMonitor',
      },
      {
        id: 203,
        primary: 'Closeout',
        to: '/closeout',
        icon: (
          <Icon>
            <CloseOutIcon />
          </Icon>
        ),
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Closeout',
      },
      // {
      //   id: 204,
      //   primary: 'Closeout V2.0',
      //   to: '/closeout-v2',
      //   icon: (
      //     <Icon>
      //       <CloseOutIcon />
      //     </Icon>
      //   ),
      //   collapsible: false,
      //   claimType: 'UI-Access',
      //   claimValue: 'Closeout-v2.0',
      // },
      {
        id: 205,
        primary: 'Bay Files',
        to: '/edi',
        icon: <Icon>file_copy</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'EdiManager',
      },
      {
        id: 206,
        primary: 'Shipping Lanes',
        to: '/shipping_lanes',
        icon: <Icon>edit_road</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Manage Shipper',
      },
    ],
  },
  {
    id: 300,
    primary: 'Shipping',
    to: '/',
    icon: <Icon>local_shipping</Icon>,
    collapsible: true,
    claimType: 'UI-Access',
    claimValue: 'Order Status',
    subItems: [
      {
        id: 301,
        primary: 'Order Status',
        to: '/order_status',
        icon: <Icon>receipt</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Order Status',
      },
      // {
      //   id: 10,
      //   primary: 'Tracking Shipments',
      //   to: '/tracking_shipments',
      //   icon: (
      //     <Icon>
      //       <PackageSearchIcon />
      //     </Icon>
      //   ),
      //   collapsible: false,
      //   claimType: 'Mode',
      //   claimValue: 'Development',
      // },
      {
        id: 302,
        primary: 'Wills Outbound',
        to: '/wills_outbound',
        icon: <Icon>north_east</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Wills Outbound',
      },
      {
        id: 303,
        primary: 'Wills Inbound',
        to: '/wills_inbound',
        icon: <Icon>south_west</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Wills Inbound',
      },
      {
        id: 304,
        primary: 'Wills Truck (Inbound)',
        to: '/wills_truck_inbound',
        icon: <Icon>local_shipping</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Wills Truck (Inbound)',
      },
      {
        id: 305,
        primary: 'Wills Discrepancies',
        to: '/wills_discrepancies',
        icon: <Icon>priority_high</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Wills Discrepancies',
      },
    ],
  },
  {
    id: 400,
    primary: 'Product Information',
    to: '/',
    icon: (
      <Icon>
        <ProductCatalogIcon />
      </Icon>
    ),
    collapsible: true,
    claimType: 'UI-Access',
    claimValue: 'Product Information',
    subItems: [
      {
        id: 401,
        primary: 'Fitment Lookup',
        to: '/fitment',
        icon: <Icon>square_foot</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Fitment App',
      },
      {
        id: 402,
        primary: 'Ninety Day Sales By Sku',
        to: '/ninety_day_sales_by_sku',
        icon: <Icon>receipt_long</Icon>,
        collapsible: false,
        claimType: 'UI-Access',
        claimValue: 'Ninety Day Sales By Sku',
      },
      {
        id: 403,
        primary: 'Cross Reference Search',
        to: '/cross_ref_search',
        icon: <Icon>manage_search</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Cross Reference Search',
      },
      {
        id: 404,
        primary: 'Part/Kit Search',
        to: '/product_search',
        icon: <Icon>content_paste_search</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Product Search',
      },
      {
        id: 405,
        primary: 'Generate Fitment',
        to: '/generate_fiment',
        icon: <Icon>note_add</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Generate Fitment',
      },
      {
        id: 406,
        primary: 'Class Line Description',
        to: '/cld',
        icon: <Icon>book_2</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Class Line Description',
      },
      {
        id: 407,
        primary: 'Feedonomics Data',
        to: '/feedonomics_data',
        icon: <Icon>storage</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Feedonomics Data',
      },
      {
        id: 408,
        primary: 'Inventory',
        to: '/inv',
        icon: <Icon>sync_alt</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Inventory',
      },
    ],
  },
  {
    id: 900,
    primary: 'Security',
    to: '/',
    icon: <Icon>admin_panel_settings</Icon>,
    collapsible: true,
    claimType: 'UI-Access',
    claimValue: 'Manage Security',
    subItems: [
      {
        id: 901,
        primary: 'Manage Users',
        to: '/manage_users',
        icon: <Icon>manage_accounts</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Manage Security',
      },
      {
        id: 902,
        primary: 'Manage Access',
        to: '/manage_access',
        icon: <Icon>verified_user</Icon>,
        claimType: 'UI-Access',
        claimValue: 'Manage Security',
      },
    ],
  },
  {
    id: 1000,
    primary: 'Instruction Manual',
    to: '/training',
    icon: <Icon>model_training</Icon>,
    collapsible: false,
  },
];
